import { SxProps, Theme } from '@mui/material';
import {
  container as settingsContainer,
  contentContainer as settingsContent,
  titleRow as settingsTitleRow,
} from 'src/presentation/settings/styles';

export const pageContainer = settingsContainer;
export const contentContainer = settingsContent;
export const titleRow = settingsTitleRow;

export const billingCard: SxProps<Theme> = {
  p: { xs: 2, sm: 3 },
  mx: { xs: 1.5, sm: 0 },
  borderRadius: 3,
  border: theme => `1px solid ${theme.palette.divider}`,
  backgroundColor: theme => theme.palette.background.paper,
};

export const locationCard: SxProps<Theme> = {
  p: { xs: 2, sm: 2.5 },
  borderRadius: 2,
  border: theme => `1px solid ${theme.palette.divider}`,
  backgroundColor: theme =>
    theme.palette.mode === 'light'
      ? theme.palette.grey[50]
      : theme.palette.background.paper,
  '&:hover': {
    borderColor: theme => theme.palette.primary.light,
    boxShadow: theme => theme.shadows[1],
  },
};

export const toggleGroup: SxProps<Theme> = {
  '& .MuiToggleButton-root': {
    textTransform: 'none',
    px: 2,
  },
};

export const headerActions: SxProps<Theme> = {
  mt: { xs: 1, sm: 0 },
  width: { xs: '100%', sm: 'auto' },
  justifyContent: { xs: 'space-between', sm: 'flex-end' },
};

export const expandButton: SxProps<Theme> = {
  transition: theme =>
    theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
};

export const planGrid: SxProps<Theme> = {
  mt: 1,
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    md: 'repeat(3, minmax(0, 1fr))',
  },
  gap: 2,
};

export const planCard: SxProps<Theme> = theme => ({
  p: 2.5,
  borderRadius: 2.5,
  border: `1px solid ${theme.palette.divider}`,
  height: '100%',
  display: 'flex',
});

export const popularPlanCard: SxProps<Theme> = theme => ({
  ...planCard(theme),
  elevation: 2,
  border: `2px solid ${theme.palette.primary.main}`,
  backgroundColor: theme.palette.action.hover,
});

export const featureList: SxProps<Theme> = {
  mt: 0.5,
  mb: 0,
  pl: 2,
  listStyle: 'disc',
};

export const planBody: SxProps<Theme> = {
  height: '100%',
  flexGrow: 1,
};

export const priceFrequency: SxProps<Theme> = {
  mt: 0.25,
};

export const buttonLoader: SxProps<Theme> = {
  mr: 1,
};
